import React from "react";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  getTheme,
  mergeStyleSets,
  PrimaryButton,
  Text,
} from "@fluentui/react";

const dialogContentProps = {
  type: DialogType.normal,
  title: "Reset Timer",
};

const getClassNames = (theme) =>
  mergeStyleSets({
    description: {
      display: "inline-block",
      fontWeight: "bold",
    },
    footer: {
      marginTop: theme.spacing[12],
    },
    cancelBtn: {
      color: theme.palette.themePrimary,
      border: `2px solid ${theme.palette.themePrimary}`,
    },
    resetBtn: {
      background: theme.palette.errorRed,
      border: `1px solid ${theme.palette.errorRed}`,
      color: theme.palette.white,
      selectors: {
        ":hover": {
          background: theme.palette.errorRed,
        },
      },
    },
  });

const ResetTimeDialog = ({ open, handleOpen, onReset }) => {
  let theme = getTheme();
  let { footer, cancelBtn, resetBtn } = getClassNames(theme);
  return (
    <Dialog hidden={!open} onDismiss={() => handleOpen(false)} dialogContentProps={dialogContentProps}>
      <Text variant="mediumPlus">Are you sure you want to reset the timer?</Text>
      <DialogFooter className={footer}>
        <DefaultButton className={cancelBtn} onClick={() => handleOpen(false)} text="Cancel" />
        <PrimaryButton className={resetBtn} onClick={onReset} text="Reset" />
      </DialogFooter>
    </Dialog>
  );
};

export default ResetTimeDialog;
